import { GQLResponsePerimeterXChallengeError } from '@change-corgi/core/gql';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	StarterDashboardPetitionRecentSignersConnectionDataQuery,
	StarterDashboardPetitionRecentSignersConnectionDataQueryVariables,
} from '../petitionRecentSigners.graphql';
import { StarterDashboardPetitionRecentSignersConnectionData } from '../petitionRecentSigners.graphql';

type SuccessResponse = NonNullable<
	StarterDashboardPetitionRecentSignersConnectionDataQuery['petition']
>['recentSignersConnection'] & {
	__typename: 'PetitionRecentSignersConnectionSuccess';
};

export async function getPetitionRecentSigners(
	{ gql: { fetch }, errorReporter }: UtilityContext,
	{ slug }: { slug: string },
): Promise<SuccessResponse | null> {
	try {
		const { data } = await fetch<
			StarterDashboardPetitionRecentSignersConnectionDataQuery,
			StarterDashboardPetitionRecentSignersConnectionDataQueryVariables
		>({
			batched: false, // to ensure this rate limited mutation is not batched
			path: '/petitionRecentSigners',
			query: StarterDashboardPetitionRecentSignersConnectionData,
			rejectOnError: true,
			variables: { slug },
		});

		if (data.petition?.recentSignersConnection.__typename === 'PetitionRecentSignersConnectionSuccess') {
			return data.petition.recentSignersConnection;
		}
	} catch (error) {
		if (error instanceof GQLResponsePerimeterXChallengeError) {
			void errorReporter.report({
				error,
				params: {
					petitionSlug: slug,
					action: 'getPetitionRecentSigners',
					message: 'PerimeterX error while fetching petition recent signers on starter dashboard',
				},
			});
		}
	}

	return null;
}
